<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">

        <template v-if="$store.getters.role == 1">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <!-- <div class="page-name">List Tickets</div> -->
                    <div class="page-name">Locations</div>
                    <!--<button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>-->
                    <button type="submit" v-on:click.prevent="addLocation" class="btn btn-primary waves-effect pull-right">Add Location</button>
                </div>

                <div class="admin-page-content">
                    <!-- List Content Here -->
                    <!-- List Content Here -->
                    <div class="card">
                        <div class="card-body">
                            <vue-good-table
                                ref="listLocationTable"
                                mode="remote"
                                title="List Location"
                                @on-page-change="onPageChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                @on-selected-rows-change="selectionChanged"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :searchOptions="{enabled: true,placeholder:'Search by Location'}"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'pages',
                                    pageLabel: 'Page',
                                    position: 'bottom',
                                    perPage: serverParams.perPage,
                                    setCurrentPage: serverParams.setCurrentPage,
                                    perPageDropdown: [10, 20, 30, 40 ,50],
                                    dropdownAllowAll: false,
                                }">

                                <!-- Custome Pagination -->
                                <template slot="pagination-bottom" slot-scope="props">
                                    <div class="vgt-wrap__footer crm">
                                        <div  class="row">
                                            <div class="col-sm-12 col-md-2 PerPage">
                                                <v-select title="Select Per Page"
                                                    v-model="serverParams.perPage"
                                                    @change="changedValueTask"
                                                    @input="changedValueTaskCustomPerPageTask()"
                                                    name="customPerPage"
                                                    id="customPerPage"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="serverParams.perPageDropdown"
                                                    placeholder="Select Per Page">
                                                </v-select>
                                            </div>
                                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                            </div>
                                            <div class="col-sm-12 col-md-6 Pagination">
                                                <ul class="pagination">
                                                    <li class="FirstPage" title="First Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                        </template>
                                                    </li>
                                                    <li class="page-item PreviousPage" title="Previous Page">
                                                        <template v-if="Number(serverParams.page) == 1">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                        </template>
                                                    </li>
                                                    <template v-if="pageNumberListTask() < displayPageTask">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <!--End New Implementation-->
                                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                            <template v-for="(n, index) in displayPageTask">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                            <template v-for="(n, index) in pageNumberListTask()">
                                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                        <a class="page-link" href="javascript:void(0)">
                                                                            {{n}}
                                                                        </a>
                                                                    </li>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <li class="page-item NextPage" title="Next Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                        <template v-else>
                                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                        </template>
                                                    </li>
                                                    <li class="LastPage" title="Last Page">
                                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                        <template v-else>
                                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <p class="pageJumpLabel">Page : </p>
                                            </div>
                                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- End Custome Pagination -->

                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'actions'">
                                        <button type="button" class="btn btn-primary  btn-sm" v-on:click="editLocation(props.row.location_id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    </span>
                                    <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>

                <div class="modal fade location-modal" id="locationModal" role="dialog">
                    <div class="modal-dialog modal-sm">
                        <div class="modal-content">
                            <div class="modal-header">

                                <h4 class="modal-title" id="editModelTitle">Edit Printer</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">

                                <!-- Location Name -->
                                <div class="form-group" id="location">
                                    <label for="start_ticket_no">Location</label>
                                    <input type="text" class="form-control" name="location" v-model="locationData.location" />
                                    <label class="text-danger" v-if="error.location_error">{{ error.location_error}}</label>
                                </div>

                                <!-- State -->
                                <div class="form-group" id="state">
                                    <label >Select State</label>
                                    <v-select v-model="selectedState" @input="onChnageState()" name="selectedState" placeholder="Type state here"
                                            label="name"
                                            :options="stateOptions" class="">
                                    </v-select>
                                    <label class="text-danger" v-if="error.state_error">{{ error.state_error}}</label>
                                </div>

                                <!-- TimeZone -->
                                <div class="form-group my-5" id="timezone">
                                    <label >Select TimeZone</label>
                                    <v-select v-model="selectedtimezone" @input="onChnageTimeZone()" name="selectedtimezone" placeholder="Type timezone here"
                                            label="name"
                                            :options="timezoneOptions" class="">
                                    </v-select>
                                    <label class="text-danger" v-if="error.timezone_error">{{ error.timezone_error}}</label>
                                </div>

                                <!-- Department -->
                                <div class="form-group" id="department">
                                    <label >Select Department</label>
                                    <v-select v-model="selecteddepartment" @input="onChnageDepartment()" name="selecteddepartment" placeholder="Type department here"
                                            label="name"
                                            :options="departmentOptions" class="">
                                    </v-select>
                                    <label class="text-danger" v-if="error.department_error">{{ error.department_error}}</label>
                                </div>


                                <div class="form-group">
                                    <label for="start_ticket_no">Start Ticket Number</label>
                                    <input type="text" class="form-control" name="start_ticket_no" id="start_ticket_no" v-model="locationData.start_ticket_no" />
                                </div>

                                <div class="form-group">
                                    <label for="ip-address">Enter IP Address</label>
                                    <!--<input v-model="locationData.ip_address" type="text" class="form-control" name="ip-address" id="ip-address"  placeholder="Enter IP Address">-->
                                    <vue-ip-input :ip="locationData.ip_address" :on-change="onIpChange" :on-blur="onIpBlur" type="text" class="form-control" name="ip-address" id="ip-address" ></vue-ip-input>
                                    <label class="text-danger" v-if="error.ip_address">{{ error.ip_address}}</label>
                                </div>

                                <div class="form-group">
                                    <label >Select Printer</label>
                                    <v-select v-model="selectedPrinter" @input="onChnagePrinter()" name="selectedPrinter" placeholder="Type printer here"
                                            label="printer_version"
                                            :options="printerOptions" class="">
                                    </v-select>
                                    <label class="text-danger" v-if="error.printer_error">{{ error.printer_error}}</label>
                                </div>

                                <div class="form-group  pt-5">
                                    <label for="ip-address">Shop Close Time</label>
                                    <!--<input v-model="locationData.ip_address" type="text" class="form-control" name="ip-address" id="ip-address"  placeholder="Enter IP Address">-->
                                    <date-picker v-model="locationData.close_time" :config="bootstrapOptionsTime" class="form-control" placeholder="Select Close Time" name="bootstrapdate1">
                                    </date-picker>
                                    <label class="text-danger" v-if="error.ip_address">{{ error.closeTime}}</label>
                                </div>



                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                                <button id="updateBtn" class="btn btn-warning" v-on:click="updateLocation()">Update</button>
                                <button id="saveBtn" class="btn btn-warning" v-on:click="saveLocation()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>

</template>

<script>
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import {HTTP} from '../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import vSelect from 'vue-select';
    import { commonMixins } from "../mixins/commonMixins";

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    var VueIpInput = require('vue-ip-input');
    var self;

    export default {
        name: "ListLocation",
        components: {
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
             vSelect,
            'vue-ip-input': VueIpInput,
            datePicker,
        },
        mixins: [commonMixins],
        data() {
            return {
                locationData:{
                    location: '',
                    location_id:'',
                    ip_address:'',
                    printer_id:'',
                    start_ticket_no: 1,
                    close_time: '',
                    flag:false,
                },
                selectedState: '',
                stateOptions: [],
                selectedtimezone: '',
                timezoneOptions: [],
                selecteddepartment: '',
                departmentOptions: [],

                bootstrapOptionsTime: {
                    /*format: 'MM/DD/YYYY',
                    useCurrent: false,*/
                    format: 'hh:mm A',
                    useCurrent: false,
                    showClear: true,
                    showClose: true,
                    allowInputToggle: true,
                    // use24hours: true
                },
                closeTime: '',
                firstLoad: 0,
                columns: [
                    {
                        label: 'Location Name',
                        field: 'location_name',
                        filterable: false,
                    },
                    {
                        label: "Start Ticket#",
                        field: "start_ticket_no",
                        type: "number",
                        filterable: false,
                    },
                    {
                        label: 'IP Address',
                        field: 'ip_address',
                        type: 'number',
                        filterable: false,
                    },
                    {
                        label: 'Printer Series',
                        field: 'printer_series',
                        type: 'number',
                        filterable: false,
                    },
                    {
                        label: 'Printer Version',
                        field: 'printer_version',
                        filterable: false,
                    },
                    {
                        label: 'Close Time',
                        field: 'close_time',
                        filterable: false,
                    },
                    {
                        label: 'Actions',
                        field: 'actions',
                        sortable: false,
                    },

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 10,
                    perPageDropdown : [10, 20, 30, 40, 50],
                    setCurrentPage: 1,
                },
                displayPageTask: 7,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                jumpToPageTask: 0,
                selectedPrinter:'',
                printerOptions:[],
                error:{
                    ip_address:'',
                    printer_error : '',
                    close_time : '',
                    state_error : '',
                    timezone_error : '',
                    department_error : '',
                    location_error : '',
                },
            }
        },
        watch: {
            selectedPrinter: function (printer) {
                let app = this;
                if (app.selectedPrinter == null) {
                    app.locationData.printer_id = "";
                } else {
                    app.locationData.printer_id = app.selectedPrinter.id;
                    // console.log(app.locationData.printer_id );
                }
            },
        },
        beforeMount: function() {
            self = this;
        },
        mounted:function(){
            let self = this;

            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            self.loadLocations();
            self.loadPrinters();
            self.loadState();
            self.loadTimeZone();
            self.loadDepartment();
            // $("#ip-address").ipAddress;
            $("#ip-address").keyup(function(){
                self.error.ip_address='';
            });
        },
        methods: {

            loadDepartment: function() {
              let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.get('department',config)
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == '200') {
                            self.departmentOptions= response.data.content;
                        }

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },

            loadTimeZone: function() {
              let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.get('timezone',config)
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == '200') {
                            self.timezoneOptions= response.data.content;
                        }

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            loadState: function() {
              //
              let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.get('state',config)
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == '200') {
                            self.stateOptions= response.data.content;
                        }

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            addLocation: function () {
              $('#locationModal').modal('show');
              $('#editModelTitle').text('Add Location');
              $('#location').show();
              $('#state').show();
              $('#timezone').show();
              $('#department').show();
              $('#updateBtn').hide();
              $('#saveBtn').show();
            },
            saveLocation: function() {
              var error = false;
              self.error.location_error = '';
              self.error.ip_address = '';
              self.error.printer_error = '';
              self.error.close_time = '';
              self.error.state_error = '';
              self.error.timezone_error = '';
              self.error.department_error = '';

              if (!self.locationData.location || self.locationData.location == null || self.locationData.location == "") {
                  self.error.location_error = "The Location Name is required.";
                  error = true;
              }
              if (!self.selectedState || self.selectedState == null || self.selectedState == "") {
                  self.error.state_error = "The State is required.";
                  error = true;
              }
              if (!self.selectedtimezone || self.selectedtimezone == null || self.selectedtimezone == "") {
                  self.error.timezone_error = "The Timezone is required.";
                  error = true;
              }
              if (!self.selecteddepartment || self.selecteddepartment == null || self.selecteddepartment == "") {
                  self.error.department_error = "The Department is required.";
                  error = true;
              }
              if (!error) {

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                var fields = {
                                name: self.locationData.location,
                                state_id: self.selectedState.id,
                                timezone_id: self.selectedtimezone.id,
                                department_id: self.selecteddepartment.id,
                                printer_id: self.locationData.printer_id,
                                ip_address: self.locationData.ip_address,
                                start_ticket_no: self.locationData.start_ticket_no,
                                close_time: self.locationData.close_time,
                            };

                HTTP.post('add/locations',fields,config)
                    .then(function (response) {
                        console.log(response);
                        if (response.data.code == '200') {
                            $('#locationModal').modal('hide');
                            self.loadLocations();
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                          self.error = err.response.data.message;
                        }
                    })

              }

            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadLocations();
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadLocations();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadLocations();
            },
            selectionChanged() {
                var self = this;
            },
            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('location_name');
                    field:('ip_address');
                    field:('printer_series');
                    field:('close_time');
                    field:('printer_version');
                };
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.location_name || filters.ip_address || filters.printer_series || filters.printer_version) {
                    this.loadLocations();
                }
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadLocations();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadLocations();
            },
            onIpChange(ip) {
                let self=this;
                self.locationData.ip_address=ip;
                // console.log('ip input change:', ip);
            },
            onIpBlur(ip) {
                let self=this;
                self.locationData.ip_address=ip;
            },
            onChnagePrinter() {
                let self = this;
                self.error.printer_error = '';
            },
            onChnageState() {
                let self = this;
                self.error.state_error = '';
            },
            onChnageTimeZone() {
                let self = this;
                self.error.timezone_error = '';
            },
            onChnageDepartment() {
                let self = this;
                self.error.department_error = '';
            },
            loadLocations() {
                let self = this;
                self.firstLoad = 1;
                self.serverParams.setCurrentPage = self.serverParams.page;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        sort: self.serverParams.sort,
                    }
                };
                HTTP.get('locations_new', config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                            self.jumpToPageTask = self.serverParams.page;
                        }
                        // self.locationOptions= response.data.content;
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            loadPrinters(){
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.get('printers',config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            self.printerOptions= response.data.content;
                        }

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            editLocation(location_id)
            {
                let self= this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                self.locationData.location_id=location_id;
                self.error.ip_address='';
                self.error.closeTime='';
                if( self.locationData.location_id != '')
                {
                    var locationData=self.locationData;
                    HTTP.post('location/byLocationId',locationData,config)
                        .then(function (response) {
                            // console.log(response);
                            if (response.data.code == '200') {
                                if(response.data.content.ip_address=='' || response.data.content.ip_address==null)
                                {
                                    self.locationData.ip_address='0.0.0.0';
                                }else {
                                    self.locationData.ip_address=response.data.content.ip_address;
                                }

                                if(response.data.content.printer_id=='' || response.data.content.printer_id==null)
                                {
                                    self.selectedPrinter={'printer_version':'EPOS2_TM_T88','id':'14'};
                                }else{
                                    self.selectedPrinter={'printer_version':response.data.content.printer_version,'id':response.data.content.printer_id};
                                }

                                self.locationData.start_ticket_no = response.data.content.start_ticket_no;
                                self.locationData.close_time = response.data.content.close_time;

                                $('#locationModal').modal('show');
                                $('#editModelTitle').text('Edit Printer');
                                $('#location').hide();
                                $('#updateBtn').show();
                                $('#saveBtn').hide();
                                $('#state').hide();
                                $('#timezone').hide();
                                $('#department').hide();
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                              self.error = err.response.data.message;
                            }
                        })
                }
            },
            updateLocation()
            {

                let self= this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                if(self.locationData.ip_address=='' || self.locationData.ip_address==null || self.locationData.ip_address=='...' || self.locationData.ip_address=='0.0.0.0')
                {
                    self.error.ip_address = "The ip address field is required.";
                    return false;
                } else if(!self.locationData.printer_id) {
                    self.error.printer_error = "The printer field is required.";
                    return false;
                }
                //  if(!self.locationData.closeTime) {
                //     self.error.closeTime = "The printer field is required.";
                //     return false;
                // }

                if( self.locationData.location_id != '')
                {
                    var locationData=self.locationData;
                            HTTP.post('location/update', locationData, config)
                                .then(function (response) {
                                    console.log(response);
                                    if (response.data.code == '200') {
                                        $('#locationModal').modal('hide');
                                        self.loadLocations();
                                    }

                                    if (response.data.code == '201') {
                                        self.error.ip_address = response.data.content.ip_address[0];
                                    }
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                })

                }

            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ListLocation.vue